var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.175,
    height: 165.245,
    viewBox: "0 0 116.175 165.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.301,
    y1: 0.187,
    x2: 1.671,
    y2: 1.053,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f7a63b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f3d792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bde1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8ac2cb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M1090.991,402.68h-51.639a6.449,6.449,0,1,0,0,12.9h51.639a6.449,6.449,0,0,0,0-12.9Zm-38.725-50.346h6.449v6.449a6.449,6.449,0,1,0,12.9,0v-6.449h6.449a6.449,6.449,0,0,0,0-12.9h-6.449v-6.449a6.449,6.449,0,1,0-12.9,0v6.449h-6.449a6.449,6.449,0,0,0,0,12.9Zm38.725,24.534h-51.639a6.449,6.449,0,1,0,0,12.9h51.639a6.449,6.449,0,0,0,0-12.9Zm25.827-87.794h-20.482a19.41,19.41,0,0,0-18.259-12.914H1052.25a19.389,19.389,0,0,0-18.259,12.914h-20.482a6.447,6.447,0,0,0-6.449,6.449V434.956a6.447,6.447,0,0,0,6.449,6.449h103.278a6.446,6.446,0,0,0,6.449-6.449V295.523a6.446,6.446,0,0,0-6.449-6.449Zm-64.552,0h25.827a6.449,6.449,0,0,1,0,12.9h-25.827a6.449,6.449,0,0,1,0-12.9Zm58.1,139.433h-90.364V301.987h14.017a19.41,19.41,0,0,0,18.259,12.914h25.827a19.388,19.388,0,0,0,18.259-12.914h14.017v126.52Z",
    transform: "translate(-1007.06 -276.16)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.2a2e7f120c489b4957249d8f5829a38a.svg";
export { ForwardRef as ReactComponent };